// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"315":"ef6332cb","595":"11886b67"}[chunkId] + ".css";
};